// This component handles the App template used on every page.
import React, { Component } from 'react';
//import Header from '../screens/components/basic/Header';
import { connect } from 'react-redux';
import injectTapEventPlugin from 'react-tap-event-plugin';
import Snackbar from './components/basic/Snackbar';
import DialogAlert from './components/basic/DialogAlert';
import DialogLoading from './components/basic/DialogLoading';
import LoginDialog from './containers/account/LoginDialog';
import PastDueDialog from './containers/account/PastDueDialog';
// import BranchDialog from './containers/account/BranchDialog';
import BranchDialogHighTides from './containers/account/BranchDialogHighTides';
import ChangePasswordDialog from './containers/account/ChangePasswordDialog';
import BaseContainer from './components/basic/BaseContainer';
import { showError } from 'actions/CommonActions';
import LOOKUP from 'constants/lookup';
import CheckinDialog from './components/advanced/CheckinDialog';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Outlet } from 'react-router-dom';

// injectTapEventPlugin();

class App extends Component {
  constructor(props, context) {
    super(props)
    // super(props, context);
  }

  componentDidMount() {
    if (localStorage.getItem("IsLoggedOut") != "true") {
      const folder = JSON.parse(localStorage.getItem('TECHPOS_FolderName')) || null;
      const path = window.location.pathname;
      const pattern = new RegExp(`^/${folder}(/|$)`);
      if (folder && !pattern.test(path)) {
        window.location.href = `/${folder}`;
      }
    }
    this.checkStyle();
  }

  componentDidUpdate(newProps) {
    if (this.props.unauthorizedUser && newProps.unauthorizedUser !== this.props.unauthorizedUser && newProps.unauthorizedUser === true) {
      this.showUnauthorizedDialog();
    }

    if (newProps.version && newProps.version !== this.props.version && newProps.version !== localStorage.getItem("TECHPOS_VERSION")) {
      localStorage.setItem("TECHPOS_VERSION", newProps.version);
      if (caches) {
        // Service worker cache should be cleared with caches.delete()
        caches.keys().then((names) => {
          for (const name of names) {
            caches.delete(name);
          }
        });
      }
      if (localStorage.getItem("IsLoggedOut") != "true") {
        window.location.reload(true);
      } else {
        window.location.href = "/";
      }
    }
  }

  showUnauthorizedDialog = () => {

    this.props.showDialog(LOOKUP.authentication.unauthorizedMessage);
  }

  checkStyle = () => {
    // if (localStorage.getItem("classic") == 1) {
    //   require("./classic.css");
    // }
  }

  render() {
    const theme = createTheme({
      palette: {
        primary: {
          main: '#7A60E5',
          light: '#5F4BB3',
        },
        secondary: {
          main: '#5F4BB3',
        },

      },
      components: {
        MuiAppBar: {
          styleOverrides: {
            root: {
              backgroundColor: '#404042',
            },
          },
        },
        MuiTextField: {
          defaultProps: {
            InputLabelProps: {
              // shrink: false,
            },
          },
        },
        MuiFormLabel: {
          styleOverrides: {
            root: {
              '&.Mui-focused': {
                color: 'inherit',
              },
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              backgroundColor: 'transparent',
              '&.Mui-focused': {
                backgroundColor: 'transparent',
              },
              '&.Mui-filled': {
                backgroundColor: 'transparent',
              },
              '&.Mui-valid': {
                backgroundColor: 'transparent',
              },
            },
            input: {
              '&:focus': {
                backgroundColor: 'transparent',
              },
              '&:filled': {
                backgroundColor: 'transparent',
              },
              '&:valid': {
                backgroundColor: 'transparent',
              },
            },
          },
        },
        MuiButton: {
          styleOverrides: {
            outlined: {
              backgroundColor: 'transparent',
              borderColor: 'transparent',
              color: '#000',
              fontSize: '13px',
              boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
              '&:hover': {
                backgroundColor: '#EBEBEB',
                borderColor: 'transparent',
                boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',

              },
            },
            root: {
              '&.MuiButton-secondary': {
                backgroundColor: '#ff5722',
                boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
                '&:hover': {
                  backgroundColor: '#e64a19',
                },

              },
            },
          },
        },
        MuiDialog: {
          styleOverrides: {
            paper: {

              borderRadius: 0,
              padding: 0,

              boxShadow: '0px 14px 15px rgba(0, 0, 0, 0.25)',
            },
          },
        },
        MuiDialogTitle: {
          styleOverrides: {
            root: {
              fontSize: '14px',
              fontWeight: 500,
              padding: '0',
            },
          },
        },
        MuiDialogContent: {
          styleOverrides: {
            root: {
              padding: '16px 24px',
            },
          },
        },
        MuiDialogActions: {
          styleOverrides: {
            root: {
              padding: '8px 16px',
              justifyContent: 'flex-end',
            },
          },
        },
        MuiAutocomplete: {
          styleOverrides: {
            root: {
              '& .MuiAutocomplete-inputRoot': {
                borderRadius: '4px',
                padding: '8px',
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                },
              },
              '& .MuiAutocomplete-popupIndicator': {
                color: '#1976d2',
              },
            },
          },
        },
      },
    });


    const url = window.location.href;
    let renderChildren = this.props.isUserAuthenticated;
    if ((url.indexOf('clock-in') !== -1)) {
      renderChildren = true;
    }

    return (
      <ThemeProvider theme={theme}>
        <div className="container_push">
          {
            this.props.isUserAuthenticated === true ? (
              <BaseContainer>
                {
                  this.props.unauthorizedUser === true ?
                    (<LoginDialog tokenExpire={true} />)
                    : (renderChildren ? <Outlet /> : null)
                }
              </BaseContainer>
            )
              : null
          }
        </div>
        {
          this.props.isUserAuthenticated === true ? (
            <footer className="footer-copyright text-center">
              <p> © 2017-{new Date().getFullYear()} TECHPOS All Rights Reserved | Version {this.props.version} </p>
            </footer>
          )
            : null
        }
        <LoginDialog />
        <PastDueDialog />
        <BranchDialogHighTides />
        <ChangePasswordDialog />
        <Snackbar open={false} message="" />
        <DialogAlert open={false} message="" />
        <DialogLoading open={this.props.loading} message={this.props.loadingMsg} />
         {this.props.checkInDialog && <CheckinDialog open={this.props.checkInDialog} />}
      </ThemeProvider>
    );
  }
}

function mapStateToProps(state) {
  return {
    loading: (state.common.ajaxCallsInProgress > 0) || state.common.loading,
    loadingMsg: state.common.loadingMsg,
    isUserAuthenticated: state.common.isUserAuthenticated,
    unauthorizedUser: state.common.unauthorizedUser,
    applicationSetting: state.common.applicationSettings,
    branchId: state.common.branchId,
    checkInDialog: state.common.checkInDialog,
    version: state.common.store.version
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showDialog: (message) => dispatch(showError(message))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
